import { Button, styled } from '@mui/material';
import { colors } from '../../../theme';

export const CTAButton = styled(Button)({
  backgroundColor: colors.signalOrange,
  color: colors.pureWhite,
  fontWeight: 600,
  padding: '10px 24px',
  borderRadius: '8px',
  textTransform: 'none',
  transition: 'opacity 0.3s ease-in-out, transform 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: colors.signalOrangeHover,
    color: colors.pureWhite,
    transform: 'translateY(-1px)',
    boxShadow: colors.shadows.orange,
  },
});
